import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { hasLandingPagesPermissions } from "@services/useLandingPagesPermissions";

const LandingPage = lazy(() =>
  import("@scenes/MessageComposition/LandingPages/LandingPage").then((module) => ({
    default: module.LandingPage,
  }))
);

export const landingPagesDetailsNRO: NavigationRoutingObject = {
  section: "messaging",
  Component: LandingPage,
  componentFeatureFlippers: ["landing_pages"],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("landing-pages-nro-heading", "Landing Pages"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "landing-pages-nro-description",
      "Build standalone web pages that drive conversions and grow your subscriber list"
    ),
  icon: "new-nav-system-landing-pages",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const isLandingPagesEnabled = featureOn("landing_pages");
    const { canReadLandingPages } = hasLandingPagesPermissions({
      hasPermission,
    });

    return isLandingPagesEnabled && canReadLandingPages;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/landing_pages/:appGroupId",
};
